import {
  QueryClient,
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { dashboardKeys } from '@core/react-query/features/dashboard'
import { profileKeys } from '@core/react-query/features/profile'
import { ICheckInSession } from '@core/entities/checkIn'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const getCheckInPermitUsersMutationOptions = (
  queryClient: QueryClient,
  options: Parameters<typeof useCheckInPermitUsers>[0] = {},
): Parameters<typeof useCheckInPermitUsers>[0] => ({
  ...options,
  ...permitKeys.checkIn,
  onSuccess: (_, variables, context) => {
    queryClient.invalidateQueries(
      permitKeys.byId({ permitId: variables.permitId }).queryKey,
    )
    queryClient.invalidateQueries(dashboardKeys.getDashboardPermitStats._def)
    queryClient.invalidateQueries(profileKeys.getUserStats._def)
    options.onSuccess?.(_, variables, context)
  },
})

export const useCheckInPermitUsers = (
  options: UseMutationOptions<
    ICheckInSession[],
    RequestErrorType,
    RequestTypes['checkIn']
  > = {},
) => {
  const queryClient = useQueryClient()

  return useMutation(getCheckInPermitUsersMutationOptions(queryClient, options))
}
